import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { CompetitorRow } from "./TopRankingWidgetComponents";
import { WidgetLoader } from "../widget-loader";
import { useGetTopCompetitors, useGetWhiskerDistribution } from "@piiqtechnologies/ui-lib";
import { WhiskerRangeChart } from "./WhiskerRangeChart";
const EMPTY_COMPETITORS = Array.from({ length: 5 }, (_, i) => ({
    subjectId: "",
    subjectName: "-",
    appearanceRate: 0,
    bestPerformingSubcategories: [],
    mostCitedBy: [],
}));
export const TopRankingWidget = ({ subjectId, isCompleted, whiskerData, assessmentId, }) => {
    var _a;
    const intl = useIntl();
    const [fetchTopCompetitors, topCompetitorsData, competitorsLoading] = useGetTopCompetitors();
    const [fetchWhiskerData, fetchedWhiskerData, whiskerLoading] = useGetWhiskerDistribution();
    useEffect(() => {
        if (subjectId) {
            fetchTopCompetitors(subjectId, assessmentId);
            fetchWhiskerData(subjectId, assessmentId);
        }
    }, [subjectId, isCompleted, assessmentId, fetchTopCompetitors, fetchWhiskerData]);
    const rankingData = (_a = topCompetitorsData === null || topCompetitorsData === void 0 ? void 0 : topCompetitorsData.topCompetitors) !== null && _a !== void 0 ? _a : [];
    const distributionData = fetchedWhiskerData !== null && fetchedWhiskerData !== void 0 ? fetchedWhiskerData : whiskerData;
    const loading = competitorsLoading || whiskerLoading;
    if (loading) {
        return (React.createElement(PeekStack, { id: "toprank" },
            React.createElement(WidgetLoader, null)));
    }
    const isEmpty = !rankingData.length && !distributionData;
    const displayRows = rankingData.length ? rankingData : EMPTY_COMPETITORS;
    return (React.createElement(PeekStack, { id: "toprank", sx: Object.assign({}, (isEmpty && { minHeight: 670 })) },
        React.createElement(PeekStack, { spacing: 2, sx: { flex: 1 } },
            !isEmpty &&
                ((distributionData === null || distributionData === void 0 ? void 0 : distributionData.appearanceRateBenchmark) ? (React.createElement(WhiskerRangeChart, { distribution: distributionData.appearanceRateBenchmark.distribution, yourValue: distributionData.appearanceRateBenchmark.yourValue, yourRank: distributionData.appearanceRateBenchmark.yourRank })) : (React.createElement(WhiskerRangeChart, null))),
            React.createElement(PeekStack, { sx: {
                    listStyle: "none",
                    p: 0,
                    m: 0,
                    flex: isEmpty ? 1 : undefined,
                } },
                React.createElement(PeekStack, { spacing: isEmpty ? 3 : 2, divider: React.createElement(PeekBox, { sx: { borderBottom: 1, borderColor: "divider" } }), sx: {
                        flex: 1,
                        justifyContent: isEmpty ? "space-between" : undefined,
                        "& > li": isEmpty ? { py: 2, flex: 1, display: "flex", alignItems: "center", minHeight: 100 } : undefined,
                    } }, displayRows.map((row, index) => (React.createElement(CompetitorRow, { key: row.subjectId || index, competitor: row, rank: index + 1 }))))))));
};
export default TopRankingWidget;
